export default {
  getRecipesList() {
    return this.http('ExerciseCheck', 'get', 'api/v1/recipes/nice_recipe.json')
      .then((res) => {
        return res;
      });
  },

  changeRecipesList(options) {
    return this.http('ExerciseCheck', 'post', 'api/v1/recipes', options)
      .then((res) => {
        return res;
      });
  }
};
